import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { handleGetRequest } from '../../utils/api-handler.util'
import { QueryKeys } from '../../utils/queryKeyGenerator'
import RetailerList from '../../components/retailers/RetailersList'
import PageTitle from '../../components/common/PageTitle'
import Pagination from '../../components/common/Pagination'
import SeoHelmet from '../../components/common/SeoHelmet'
import USER_TYPE from '../../constants/userType'
import TopShopSection from '../../components/retailers/TopShopSection'

const WholesalersListingPage = () => {
  const [currentPage, setCurrentPage] = useState(1)
  const { data: wholesalersData } = useQuery({
    queryKey: QueryKeys.wholesalersList(currentPage),
    queryFn: () => handleGetRequest('/wholesellers', { page: currentPage }),
  })

  const wholesalers = (wholesalersData?.data || []).map((wholesaler) => ({
    ...wholesaler,
    id: wholesaler.shopId,
    name: wholesaler.shopName,
    shopPicture: wholesaler.shopPicture,
  }))

  return (
    <div className="main-container">
      <SeoHelmet
        title="Browse Wholesalers"
        description="Find trusted wholesalers in Eastleigh offering bulk products at competitive prices. Connect with verified wholesale suppliers for your business needs."
        keywords="Eastleigh wholesalers, bulk suppliers, wholesale marketplace, Kenya wholesalers, bulk buying, Sokooni wholesale"
        url="/wholesellers"
      />
      <PageTitle>Wholesalers</PageTitle>
      <TopShopSection userType={USER_TYPE.wholeseller} title="Top Wholesaler shops" />
      <div className="mt-6">
        <section>
          <RetailerList retailers={wholesalers} />
        </section>
        <Pagination paginationMeta={wholesalersData?.meta} onPageChange={setCurrentPage} />
      </div>
    </div>
  )
}

export default WholesalersListingPage
